/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Lock_LabelInputs */



/**
* | output |
* | --- |
* | "Lock Event Group" |
*
* @param {Edit_Event_Group_Lock_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_lock_label = /** @type {((inputs?: Edit_Event_Group_Lock_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Lock_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lock Event Group")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lock Event Group")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lock Event Group")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Lock Event Group")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lock Event Group")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Lock Event Group")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Lock Event Group")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Lock Event Group")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lock Event Group")
	return /** @type {LocalizedString} */ ("Lock Event Group")
});